import React from 'react';
import {baseUrl} from '../baseUrl/index';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#ff3300e1',
    },
    secondary: {
      main: 'rgb(0, 0, 0)',
    },
  },
};
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: themeOptions.palette.primary.main,
}));

// const Main = styled('main')(
//   ({ theme }) => ({
//     flexGrow: 1,
//     padding: theme.spacing(0),
//     transition: theme.transitions.create('margin', {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     })
//   }),
// );

export default function TodayActiveUsers() {
  const theme = useTheme();
  const [row, setRow] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user_id, setUser_id] = useState('');
  const [expireddate, setExpireddate] = useState('null');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    onload();
  }, [])

  // useEffect(() => {
  //   console.log('testtt:', row);
  // }, [row])

  const onload = async () => {
    axios.get(`${baseUrl}today_active_users`).then(({ data }) => {
      // console.log(data.data.records_1);
      const datas = data.data.records_1.map((res) => {
        return (
          {
            // sq_no: i + 1,
            email: res.email_id ? res.email_id : '--NA--',
            id: res.user_id,
            device_id: res.device_id,
            device_info: (
              <div>
                {res.device_name}
                <Divider orientation="vertical" flexItem />
                {res.device_os}
                <Divider orientation="vertical" flexItem />
                {res.device_version}
              </div>
            ),
            plan_name: (res.plan_name === 'com.weekly') ? 'Weekly' :
              (res.plan_name === 'com.monthly' ? 'Monthly' :
                (res.plan_name === 'com.3months' ? '3 Months' :
                  (res.plan_name === 'com.6months' ? '6 Months' :
                    (res.plan_name === 'com.6months' ? 'Yearly' : 'Basic')))),
            date: (
              <div>
                PD:- {res.purchased_date}
                <Divider orientation="vertical" flexItem />
                ED:- {res.expired_date}
              </div>
            ),
            last_login: res.lastlogin_date,
            time_zone: (res.time_zone === null) ? '--NA--' : res.time_zone,
          }
        )
      });
      setRow(datas);
      setLoading(false);
    }).catch((error) => {
      console.log(error)
      setLoading(false);
    })
  };

  const handleEditButtonClick = (user_id, dateComponent) => {
    // console.log('arpit:',row);
    const expired = dateComponent.props.children[4];
    // console.log('vbn:',expired);
    setUser_id(user_id)
    setExpireddate(expired)
    setOpen(true)
  };


  const handleExpiredDateChange = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD")
    setExpireddate(formattedDate);
    // console.log(setExpireddate);
  };

  const handleUpdate = async () => {
    setOpen(false);
    try {
      const response = await axios.post(`${baseUrl}editplanpurchased`, { "user_id": user_id, 'expired_date': expireddate, });
      const data = await response.data;
      if (data.status.code === 200) {
        //   navigate('/userpage');
        window.location.reload(true);
      }else{
        alert(data.status.message)
      }
    }
    catch (e) {
      console.log(e);
    }
  };


  const CustomCellRenderer = ({ value }) => {
    return <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-all' }}>{value}</div>;
  };

  const columns = [
    // { field: 'sq_no', headerName: 'S.No', flex: 0.2, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left'},
    { field: 'email', headerName: 'Email ID', flex: 1, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left', renderCell: CustomCellRenderer },
    { field: 'device_id', headerName: 'Device ID ', flex: 1, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left', renderCell: CustomCellRenderer },
    { field: 'device_info', headerName: 'Device Info', flex: 0.6, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left', renderCell: CustomCellRenderer },
    { field: 'plan_name', headerName: 'Plan Name', flex: 0.5, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left', renderCell: CustomCellRenderer },
    { field: 'date', headerName: 'Purchased/Expired Date', flex: 1, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left', renderCell: CustomCellRenderer },
    // { field: 'expired_date', headerName: 'Expired Date', flex: 1,sortable: false, headerClassName: 'custom-header',headerAlign: 'left',align: 'left', renderCell: CustomCellRenderer },
    { field: 'last_login', headerName: 'Last Login', flex: 0.7, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left', renderCell: CustomCellRenderer },
    // { field: 'time_zone',headerName:'Time Zone',flex:0.4,sortable:false,headerClassName: 'custom-header',headerAlign: 'left',align: 'left', renderCell: CustomCellRenderer}
    {
      field: 'edit', headerName: 'Edit', flex: 0.1, sortable: false, headerClassName: 'custom-header', headerAlign: 'left', align: 'left',
      renderCell: (params) => (
        <IconButton
          onClick={() => {
            const tests=params?.id?.split('**')[0]
            handleEditButtonClick(tests, params.row.date)
          }}
          color="primary"
          aria-label="Edit"
          title="Edit"
        >
          <EditIcon color='action' />
        </IconButton>
      )
    }
  ]


  return (
    <>
        <Dialog open={open}>
          <DialogTitle>UPDATE</DialogTitle>
          <DialogContent>
            {/* <TextField id="standard-read-only-input" label="USER ID" fullWidth value={user_id} variant="standard"
              InputProps={{
                readOnly: true,
              }}
            /> */}
            <TextField id="standard-basic" label="Expired Date" variant="standard" fullWidth value={expireddate}
            />

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                // value={expireddate}
                onChange={(date) => { handleExpiredDateChange(`${date}`) }}
                renderInput={(params) => <TextField {...params} label="Expired Date" variant="standard" fullWidth
                  value={expireddate}
                // format="YYYY-MM-DD"
                />}
              />
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{setOpen(false)}}>CANCEL</Button>
            <Button onClick={handleUpdate}>UPDATE</Button>
          </DialogActions>
        </Dialog>

      <Box sx={{ flexGrow: 1 }}>
        <CssBaseline />
        <AppBar position="fixed">
          <Toolbar>
            <Button size='large' sx={{padding:'0px 0px 0px 0px',color:'#fff',justifyContent:'flex-start'}} onClick={()=>{window.history.back();}}><ArrowBackIcon/></Button>
            <img style={{ width: '50px', height: '50px', marginRight: '2px' }} src={"https://beeitech.com/images/logo/appicon.png"} alt='logo' />
            <Typography variant="h6" noWrap component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              YaYa Player
            </Typography>
          </Toolbar>
        </AppBar>

        {/* <div> */}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress style={{ 'color': '#ff3300e1' }} />
          </Box>
        ) : (
          <Box>
            <DataGrid
              autoHeight
              rowHeight={80}
              rows={row}
              getRowId={(row) => row.id + "**" + row.device_id}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
              sx={{ marginTop: 8 }}
            />
          </Box>
        )}
        {/* </div> */}
      </Box>
    </>
  )
}
